import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceMoveKanbanTaskNotificationState = createStateReducer(initialState, {
  [events.moveKanbanTaskFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "moveKanbanTask",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceMoveKanbanTaskNotificationState };
